
import React from 'react';
//import { makeStyles } from '@material-ui/core/styles';
import { withStyles  } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = theme => ({  
  root: {
    '& > *': {
      width: '35ch'     
      // width: '100%'     
    }    
  },

  small: {
    '& > *': {
      width: '15ch'     
    }    
  }

});

const onlyNumbers = (ff, e) => { 
  if(ff.maxDigits > 0) {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  }
};


const MAXLENGTH = 48;

class kFormField extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      additionalClass: '',
      error: false,
      errorMsg: ''
    } 
    //this.handleOnBlur = this.handleOnBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);

    this.classes =  {}; // useStyles();
    this.maxLength = this.props.maxLength ? this.props.maxLength : MAXLENGTH;
    this.maxDigits = this.props.maxDigits ? parseInt(this.props.maxDigits) : 0;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.value !== nextProps.value) {
      return true;
    }
    if (this.props.errorMsg !== nextProps.errorMsg) {
      return true;
    }
    if (this.state.error !== nextState.error) {
      return true;
    }
    return false;
  }


  onChange = event => {
    const { id } = this.props;
    const value = event.target.value;
    // console.log(`kFormField:onChange called ${id} : ${value}`)
    this.setState({ value, errorMsg: '' });
    return this.props.onChange(id, value);
  }

  handleOnBlur(event) {
    const target = event.target;
    //const val = target.value;  // same as ${this.textInput.current.value
    this.doValidate(target.id, target.value);
  }

  doValidate(id, val) {
    if (this.props.validator) {
      let vret = this.props.validator(id, val, true);
      this.setState({ error: vret.valid === true ? false : true });
      this.setState({ errorMsg: vret.valid === true ? '' : vret.message });
    }
  }

  // <div validate autoComplete="off"></div>
  render() {    
    const { classes, fullWidth } = this.props;
    let cname = this.props.small === "true" ? classes.small : classes.root;
    //console.log(`id : ${this.props.id}, className = ${cname},  small = ${this.props.small}`)    
    //const  classes  = this.props.small === "true" ? useStyles() : halfWidth();
    // <div autoComplete="off">
    return (
      
        <TextField  className={cname} fullWidth={fullWidth}
          id={this.props.id} label={this.props.label} variant="outlined"
          value={this.props.value}
          autoFocus={this.props.autoFocus}
          onChange={this.onChange}
          onBlur={this.handleOnBlur}
          color="primary" 
          error={this.state.error}
          required
          inputProps={{ maxLength: this.maxLength}}          
          type={this.props.type}    
          helperText={this.state.errorMsg}
          onInput={(e) => onlyNumbers(this, e)}          
        />        
//      </div>
    );
  }
}
/*
InputProps={{
  className: classes.input
}}*/
// export default kFormField;

export default withStyles(useStyles)(kFormField)


/*
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));

export default function BasicTextFields() {
  const classes = useStyles();

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <TextField id="standard-basic" label="Standard" />
      <TextField id="filled-basic" label="Filled" variant="filled" />
      <TextField id="outlined-basic" label="Outlined" variant="outlined" />
    </form>
  );
}
*/